<template><div /></template>
<script>
import claimShareMixin from '~/javascripts/mixins/claimShareMixin'
import loadingMixin from '~/javascripts/mixins/loadingMixin'

export default {
  name: 'RejectShareRequest',
  mixins: [claimShareMixin, loadingMixin],
  meta: {
    isPublic: true,
  },
  nuxtI18n: {
    paths: {
      de: '/requests/reject',
      fr: '/requests/reject',
      it: '/requests/reject',
    },
  },
  mounted() {
    const query = { ...this.$route.query }
    const { token, claim_id: claimId } = query
    if (token && claimId) {
      delete query.token
      delete query.claim_id
      this.rejectShareRequest(token, parseInt(claimId, 10))
    }
    this.$router.replace({ path: '/', query }).catch((_) => {})
  },
}
</script>
